import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'al0004',
    ecrans: ['00-2'],
    params: ['id',
        '?dlhcleint',
        '?prfcleint',
        '?dlpcleint',
        '?tdlcleint',
        '?dalcleint']
});
